import * as styles from './CommunityTitle.module.scss'

export default function CommunityTitle ({ title, showOnDesktop = false, className }) {
  return (
    <h1 className={`${styles.title} ${showOnDesktop ? styles.showDesktop : ''} ${className ?? ''}`}>{title}</h1>
  )
}
